// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as NewCampaignFormComponent from "./NewCampaignFormComponent.bs.js";

function NewCampaignModal(Props) {
  var onRefresh = Props.onRefresh;
  var onToggle = Props.onToggle;
  var vehicleTypes = Props.vehicleTypes;
  var geoRegion = Props.geoRegion;
  var zones = Props.zones;
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._1(onToggle, undefined);
                }),
              overlayClassName: "porter-form__modal-overlay",
              className: "porter-form__modal porter-form__modal-size-70-surge",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: React.createElement(NewCampaignFormComponent.make, {
                    onRefresh: (function (param) {
                        return Curry._1(onRefresh, undefined);
                      }),
                    onToggle: (function (param) {
                        return Curry._1(onToggle, undefined);
                      }),
                    vehicleTypes: vehicleTypes,
                    geoRegion: geoRegion,
                    zoneData: zones
                  })
            });
}

var make = NewCampaignModal;

export {
  make ,
  
}
/* react Not a pure module */
